// Persist a deadline, not a ticking counter, so reopening and backgrounding cannot reset it.
const key = 'tocin-forgot-otp-cooldown-until'
export default {
  data () { return { otpRemaining: 0, otpDeadline: 0, otpTicker: null, otpSending: false } },
  mounted () {
    this.refreshOtpCooldown()
    this.otpTicker = setInterval(this.refreshOtpCooldown, 500)
  },
  beforeDestroy () { clearInterval(this.otpTicker) },
  methods: {
    refreshOtpCooldown () {
      try { this.otpDeadline = Math.max(this.otpDeadline, Number(localStorage.getItem(key)) || 0) } catch (_) {}
      this.otpRemaining = Math.max(0, Math.ceil((this.otpDeadline - Date.now()) / 1000))
    },
    startOtpCooldown () {
      this.otpDeadline = Date.now() + 60000
      try { localStorage.setItem(key, String(this.otpDeadline)) } catch (_) {}
      this.refreshOtpCooldown()
    },
    otpRequestBlocked () {
      this.refreshOtpCooldown()
      return this.otpSending || this.otpRemaining > 0
    }
  }
}
